const bracelets = [
  { id: '98808544da6d40c4abfe887612299cdb', name: 'bracelet1', displayName: 'Bracelet_1', imagePath: '/images/bracelets/bracelet1.jpg'},
  { id: '63f160e6daa7452b883f4bf8df334f37', name: 'bracelet2', displayName: 'Bracelet_2', imagePath: '/images/bracelets/bracelet2.jpg'},
  { id: '702d716391f94074a6de80bd188973be', name: 'bracelet3', displayName: 'Bracelet_3', imagePath: '/images/bracelets/bracelet3.jpg'},
  { id: 'a682fa05abe14cfb98bbba4b112b9709', name: 'bracelet4', displayName: 'Bracelet_4', imagePath: '/images/bracelets/bracelet4.jpg'}
]

export { bracelets };